export abstract class Comparable<T> {
  abstract equals(t: T);
}
